import React, { useEffect, useRef } from 'react';

import { Modal, Button } from 'antd';

import '../styles.less';

interface NoteFilesModalProps {
  visible: boolean;
  refresh: () => void;
}

const NoteFilesModal: React.FC<NoteFilesModalProps> = ({ visible, refresh }) => {

  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current) {
      isInitialized.current = true;
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("NCM_LAZY_LOAD_REACT_FILES", {
          detail: {}
        }));
      }, 500);
    }
  }, [])

  return (
    <Modal
      title="Upload Files"
      centered
      open={visible}
      onCancel={() => refresh()}
      width={1300}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={refresh}>
          Close
        </Button>,
      ]}
    >
      <div id="files-root-lazy" className="antd-scope-wrap"></div>
    </Modal>
  );
};

export default NoteFilesModal;
